import _ from 'lodash';

export const PERSONAL_TBC_INDEXATION = [
  {
    endDate: new Date(2021, 6, 1),
    indexation: 0,
    startDate: new Date(2017, 6, 1),
    tbc: 1600000,
    maxTBA: 0,
    maxTBADate: '',
    unused: 0,
    ratio: 0,
  },
  {
    endDate: new Date(2023, 6, 1),
    indexation: 100000,
    startDate: new Date(2021, 6, 1),
    tbc: 1700000,
    maxTBA: 0,
    maxTBADate: '',
    unused: 0,
    ratio: 0,
  },
  {
    endDate: new Date(9999, 1, 1),
    indexation: 200000,
    startDate: new Date(2023, 6, 1),
    tbc: 1900000,
    maxTBA: 0,
    maxTBADate: '',
    unused: 0,
    ratio: 0,
  },
];

const calculateEndOfDayTransactions = (transactions) => {
  const groupTransactions = _.groupBy(transactions, transaction => transaction.date);
  return _.orderBy(Object.entries(groupTransactions).map(([dateStr, dailyTransactions]) => ({
    date: new Date(dateStr),
    total: dailyTransactions.reduce((prev, curr) => prev + curr.amount, 0),
    // eslint-disable-next-line max-len
    event: dailyTransactions.reduce((prev, curr) => (curr.id > prev.id ? curr : prev), { id: -1, event: 'none' }).event,
    id: dailyTransactions.reduce((prev, curr) => (curr.id > prev.id ? curr : prev), { id: -1 }).id,
  })), 'date');
};


export default function calculateTBC(transactions) {
  const PERSONAL_TBC_CALCULATION = _.cloneDeep(PERSONAL_TBC_INDEXATION);
  let TBA_RUNNING_BALANCE = 0;
  let MAX_TBA = 0;
  let MAX_TBA_DATE = null;
  let MAX_TBA_TBC = 1600000;
  let MAX_TBA_PERCENT = 0;

  const sortedTransactions = _.sortBy(transactions, 'date', 'desc');
  // eslint-disable-next-line max-len
  const endOfDayTransactions = calculateEndOfDayTransactions(sortedTransactions.map(transaction => ({
    ...transaction,
    amount: transaction.amount * (transaction.type === 'credit' ? 1 : -1),
  })));

  const processedTransactions = endOfDayTransactions.map(((transaction) => {
    // eslint-disable-next-line max-len
    const relevantTBCIndexactionIdx = PERSONAL_TBC_CALCULATION.findIndex(indexation => transaction.date < indexation.endDate);
    const relevantTBCIndexaction = PERSONAL_TBC_CALCULATION[relevantTBCIndexactionIdx];

    TBA_RUNNING_BALANCE += transaction.total;

    const PERSONAL_TBC = relevantTBCIndexaction.tbc;

    const REMAINING_TBC = PERSONAL_TBC - TBA_RUNNING_BALANCE;
    const USED_TBC_CAP = Math.floor((TBA_RUNNING_BALANCE / PERSONAL_TBC) * 100) / 100;

    if (TBA_RUNNING_BALANCE > MAX_TBA) {
      MAX_TBA = TBA_RUNNING_BALANCE;
      MAX_TBA_DATE = transaction.date;
      MAX_TBA_TBC = PERSONAL_TBC;
    }

    MAX_TBA_PERCENT = Math.min(Math.floor((MAX_TBA / MAX_TBA_TBC) * 100) / 100, 1);

    PERSONAL_TBC_CALCULATION.forEach((indexation, idx) => {
      if (idx > relevantTBCIndexactionIdx) {
        const newIndexation = PERSONAL_TBC_INDEXATION[idx].indexation * (1 - MAX_TBA_PERCENT);
        indexation.tbc = PERSONAL_TBC_CALCULATION[idx - 1].tbc + newIndexation;
        indexation.indexation = newIndexation;
        if (TBA_RUNNING_BALANCE > indexation.maxTBA) {
          indexation.ratio = USED_TBC_CAP;
          indexation.unused = 1 - USED_TBC_CAP;
          indexation.maxTBA = TBA_RUNNING_BALANCE;
          indexation.maxTBADate = transaction.date;
        }
      }
    });

    return {
      ...transaction,
      PERSONAL_TBC,
      TBA_RUNNING_BALANCE,
      REMAINING_TBC,
      USED_TBC_CAP,
      MAX_TBA,
      MAX_TBA_DATE,
      MAX_TBA_TBC,
      MAX_TBA_PERCENT,
    };
  }));

  return [processedTransactions, PERSONAL_TBC_CALCULATION];
}
